const NUMBER_REGEX = /^-?\d*\.?\d+$/;
const INTEGER_REGEX = /^-?\d*$/;

export class TypeHelper {
  static isInteger(val: any): val is string | number | bigint {
    return (typeof val === "string" || typeof val === "number" || typeof val === "bigint") && INTEGER_REGEX.test(String(val));
  }
  static isNumericString(val: string): boolean {
    if (!val) return false;

    return NUMBER_REGEX.test(val);
  }

  static isNullish(val: any, opts?: { compareEmptyString?: boolean }): boolean {
    if (opts?.compareEmptyString && typeof val === "string") return !val;

    return val === null || val === undefined;
  }

  static isNullishType<T>(val: T): val is undefined | null {
    return val === undefined || val === null;
  }

  static convertToDateSafe(value: any): Date | null {
    if (typeof value === "string" || typeof value === "number") {
      const date = new Date(value);

      if (!isNaN(date.getTime())) {
        return date;
      }
    }

    return null;
  }
}
